<template>
  <div id="CodeHome">
    <div class="content">
      <img src="../assets/1.png" alt="App Logo" class="logo">
      <h1>乐村淘供配app</h1>
      <p>
        乐村淘供配APP是将商城、批发、达递达物流管理系统平台端相结合的集中平台。
      </p>
            
      <button @click="downloadApp" class="download-btn">重新下载</button>
    </div>
    <div v-if="showWeChatPopup" class="wechat-popup">
      <div class="popup-content">
        <img src="../assets/tishi.jpg" alt="WeChat Popup" class="popup-image">
        <button @click="closePopup" class="close-btn">关闭</button>
      </div>
    </div>
    <div v-if="showDownloadPopup" class="download-popup">
      <div class="popup-content">
        <p>已经开始下载，请等候...</p>
        <button @click="closeDownloadPopup" class="close-btn">关闭</button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'CodeHome',
  data() {
    return {
      showWeChatPopup: false,
      showDownloadPopup: false
    };
  },
  created() {
    this.downloadApp();
  },
  methods: {
    downloadApp() {
      if (this.isWeChatBrowser()) {
        this.showWeChatPopup = true;
      } else {
        this.showDownloadPopup = true;
        setTimeout(() => {
          window.location.href = 'https://api.gxlctl.com/lct.apk';
        }, 1000); // 模拟下载延迟
      }
      try {
        axios.get('https://app.statistics.gxlctl.com/setinfo');
      } catch (error) {
        console.error('Error fetching statistics:', error);
      }
    },
    isWeChatBrowser() {
      return /MicroMessenger/i.test(navigator.userAgent);
    },
    closePopup() {
      this.showWeChatPopup = false;
    },
    closeDownloadPopup() {
      this.showDownloadPopup = false;
    }
  },
  mounted() {
    if (this.isWeChatBrowser()) {
      this.showWeChatPopup = true;
    }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.content {
  text-align: center;
}

.logo {
  width: 150px;
  height: auto;
}

.download-btn {
  background-color: #4CAF50;
  color: white;
  padding: 15px 40px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  margin-top: 20px;
  font-size: 18px;
}

.download-btn:hover {
  background-color: #45a049;
}

.wechat-popup, .download-popup {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.popup-content {
  background: white;
  padding: 20px;
  border-radius: 10px;
  max-width: 90%;
  max-height: 90%;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.popup-image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.close-btn {
  background-color: #4CAF50;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  margin-top: 20px;
}

.close-btn:hover {
  background-color: #45a049;
}
</style>